import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpUtilService } from './http-util.service';
import { CookieService } from "ngx-cookie-service";
import { take } from "rxjs/operators";

export interface ScaffoldType {
  type: string;
  title: string;
}

export type Environment = {
  production: boolean;
  suppressLog: boolean;
  cognitoUserPoolId: string;
  cognitoClientId: string;
  apiRoot: string;
  socketUrl: string;
  secureCookie: boolean;
  cookieDomain: string;
  name:string;
  domain:string
  env?: string;
  dd_applicationId?: string;
  dd_clientToken?: string;
  opmReference?: any;
  isOPM?: boolean;
  multiInstance?: boolean;
  instances?: any;
  cognitoSsoUrl?:string
};

export type InstanceDetails ={
  jsondata?: any,
  title?: string,
  name?: string,
  scaffoldType?: string,
  [x: string]: any;
}

export const ScaffoldTypes: ScaffoldType[] = [
  {
    type: 'archivev2',
    title: 'Canvas Archive'
  },
  {
    type: 'archive',
    title: 'Archive'
  },
  {
    type: 'ai-detection',
    title:'AI Detection'
  },
  {
    type: 'datax',
    title: 'Data X'
  },
  {
    type: 'designer',
    title: 'Designer'
  },
  {
    type: 'migration',
    title: 'Migration'
  }
]

@Injectable({
  providedIn: "root",
})
export class EnvironmentService{
  constructor (private http: HttpUtilService, private cookieService: CookieService) {
    this.getInstanceDetails().pipe(take(1)).subscribe(details => {
      this.setInstanceCookies();
    });
   }
  _details: InstanceDetails;
  _types: ScaffoldType[];
  currentType: string;
  selectedType: string;
  inFlightDetails: any;
  _typesSubject: BehaviorSubject<string> = new BehaviorSubject<string>(this.cookieService.get("school_domain"));
  get environment():Environment {
    return environment;
  }



  /**
   * @description Get the instance details for the current instance
   * 
   * @returns {Observable<InstanceDetails>}
   */
  getInstanceDetails (force?): Observable<InstanceDetails> {
    let details : BehaviorSubject<InstanceDetails> | Subject<InstanceDetails>;
    if(force){
      this._details = null;
      this.inFlightDetails = null;
    }
    if (this._details) {
      details = new BehaviorSubject({});
      details.next(this._details);
    } else if(this.inFlightDetails) {
      details = this.inFlightDetails;
    }else {
      details = new Subject();
      this.inFlightDetails = details;
      this.http.request('get', '/api/institution/details/basic', {}, null, false).subscribe((res: any) => {
        console.log('INSTANCE:', res);
        this._details = res;
        this.inFlightDetails = null;
        details.next(res);
      });
      
    }
    return details.asObservable();
  }
  /**
   * @description Get the instance types for the current instance
   * @returns {Observable<ScaffoldType[]>}
   */
  getInstanceTypes (): Observable<ScaffoldType[]> {
    let types = new BehaviorSubject([]);
    if (this._types) {
      types.next(this._types);
    } else {
      this.http.request('get', '/api/institution/types', {}, null, false).subscribe((res: any) => {
        this._types = res;
        types.next(res);
      })
    }
    return types.asObservable();
  }
 /**
  * @description Get the domain for the given scaffold type
  * @param type Scaffold type
  * @returns Details for the given scaffold type
  */
  getDetailsForType(type:string) {
    return this._details.instances.find(instance => instance.scaffold_type === type);
  }

 /**
  * @description Get the domain for the given scaffold type
  * @param type Scaffold type
  * @returns Domain for the given scaffold type
  */
 getTypeforDomain(domain:string): string {
  console.log(this._details)
  return this._details?.instances.find(instance => instance.sub_domain === domain)?.scaffold_type;
}

  /**
   * @description Set the selected type and update the cookies and current type accordingly
   * @param type The selected type
   */
  setSelectedType(type: string) { 
    this._typesSubject.next(type);
    this.selectedType = type;
    let details = this.getDetailsForType(this.selectedType);
    this.setCookie(
      "school_domain",
      details?.sub_domain
    );
    if(details?.environment){
      this.setCookie(
        "environment",
        details.environment
      );
    }else{
      this.setCookie(
        "environment",
        null
      );
    }
    this.currentType = this.selectedType;    
  }

  watchTypeChange(): Observable<string> {
    return this._typesSubject.asObservable();
  }

  setCookie(key: string, value: string) {
    this.cookieService.set(
      key,
      value,
      null,
      "/",
      this.environment.cookieDomain,
      true
    );
  }

  /**
   * @description Set the instance cookies
   * If the domain exists and is not 'undefined', set the currentType and selectedType to the domain
   * Otherwise, set the currentType and selectedType to the environment domain
   * Also sets the cookies for 'cog_user_pool_id', 'cog_client_id', and 'school_name'
   */
  setInstanceCookies() {
    


    this.setCookie(
      "cog_user_pool_id",
      this.environment.cognitoUserPoolId
    );
    this.setCookie(
      "cog_client_id",
      this.environment.cognitoClientId
    );
    this.setCookie(
      "school_name",
      this.environment.name
    );
    const active = this.cookieService.get('active_session');
    const authenticated = this.cookieService.get('authenticated');
    const domain = this.cookieService.get("school_domain");
    console.log("domain", domain);
    //if the domain exists and is not 'undefined', set the currentType and selectedType to the domain
    //if the user is not authenticated, set the currentType and selectedType to the environment domain
    if ((domain && domain !== 'undefined') && (active && authenticated)) {
      console.log("domain", domain);
        this.currentType = this.getTypeforDomain(domain);
        this._typesSubject.next(this.currentType);
        this.selectedType = this.currentType;
        console.log("currentType", this.currentType);
    } else {
      this.setCookie("school_domain",this.environment.domain);
      this._typesSubject.next(this.environment.domain);
      this.currentType = this.getTypeforDomain(this.environment.domain);
      this.selectedType = this.currentType;
    }
  }


}
